import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'sip-condition-groups-summary',
  templateUrl: './sip-condition-groups-summary.component.html',
  styleUrls: ['./sip-condition-groups-summary.component.scss']
})
export class SipConditionGroupsSummaryComponent implements OnInit {

  sipConditionGroup;
  @Input()
  set selection(selection: any) {
    this.initializeData(selection);
  }

  constructor() {
  }

  ngOnInit(): void {

  }

  private initializeData(selection: any): void {
    this.sipConditionGroup = selection;
  }
}
